import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import { Title } from '@angular/platform-browser';
import {TitleCasePipe} from "@angular/common";
import {NotFoundErrorComponent} from "../not-found-error/not-found-error.component";
import {UnauthorizedErrorComponent} from "../unauthorized-error/unauthorized-error.component";
import {InternalServerErrorComponent} from "../internal-server-error/internal-server-error.component";
import {BreadcrumbService} from "../../services/breadcrumb.service";

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  providers: [TitleCasePipe],
})
export class BreadcrumbComponent implements OnInit {

    breadcrumbs: IBreadcrumbItem[] = [];
    show: boolean = true;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private title: Title,
        private titleCasePipe: TitleCasePipe,
        private breadcrumbService: BreadcrumbService
    ) {
    }

    ngOnInit() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                const activeComponentType = this.route.firstChild?.component;
                //console.log("activeComponentType", activeComponentType);
    
                if (activeComponentType === UnauthorizedErrorComponent || activeComponentType === NotFoundErrorComponent || activeComponentType === InternalServerErrorComponent) {
                    this.show = false;
                } else {
                    this.show = true;
                }
    
                this.buildBreadcrumbs(this.route.root);
                this.updateTitle();
                //console.log("Breadcrumbs after NavigationEnd:", this.breadcrumbs);
                this.breadcrumbService.updateBreadcrumbs(this.breadcrumbs);
            }
        });
    
        // Initial build after component is fully initialized
        setTimeout(() => {
            this.buildBreadcrumbs(this.route.root);
            this.updateTitle();
        }, 0);
    }
    
    private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadcrumbItem[] = []): IBreadcrumbItem[] {
        const children: ActivatedRoute[] = route.children;
    
        for (const child of children) {
            const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
            if (routeURL !== '') {
                url += `/${routeURL}`;
            }
    
            let text = (child.snapshot.routeConfig?.title || child.snapshot.url[child.snapshot.url.length - 1]?.path || '') + '';

            if (text) {
                text = text.replace('_', ' ');
                const clickable = !child.snapshot.routeConfig?.data?.['breadcrumbNotClickable'];
                breadcrumbs.push({ text, url, clickable });
            }
    
            return this.createBreadcrumbs(child, url, breadcrumbs);
        }
    
        return breadcrumbs;
    }
    
    buildBreadcrumbs(route: ActivatedRoute) {
        let breadcrumbs = this.createBreadcrumbs(route);

        // dirty fix
        let cleanBreadcrumbs = [];
        for (let i = 0; i < breadcrumbs.length; i++) {
            if (i && breadcrumbs[i].url == breadcrumbs[i - 1].url) {
                cleanBreadcrumbs[cleanBreadcrumbs.length - 1] = breadcrumbs[i];
            } else {
                cleanBreadcrumbs.push(breadcrumbs[i]);
            }
        }

        this.breadcrumbs = cleanBreadcrumbs;
    }

    updateTitle() {
        this.title.setTitle(
            this.breadcrumbs
                .map(b => b.text)
                .map(this.titleCasePipe.transform)
                .join(' > ')
        );
    }
}

interface IBreadcrumbItem {
    text: string;
    url: string;
    clickable?: boolean;
}

